module.exports = global["Backbone"] = require("-!./backbone.js");


//////////////////
// WEBPACK FOOTER
// ../~/backbone/backbone.js
// module id = 69
// module chunks = 0